module.exports = __webpack_public_path__ + "static/media/06fa-prime.384a86ed.png";